

  <p-fieldset legend="FLX File Upload">

    <form [formGroup]="libFLXFileUploadForm">
      <div class="ui-g ui-fluid centered">

        <div class="ui-g-12 ui-md-3" style="padding: 0em;">
          <div class="ui-inputgroup">
            <button style="width: 105px;" pButton class="theme-button noHover" type="button" label="PUID"></button>
            <input type="text" autofocus autocomplete="off" id="createdby" formControlName="createdBy"
              placeholder="PUID" (keydown.enter)="focusMachinebarcode()">
          </div>
        </div>

        <div class="ui-g-12 ui-md-3" style="padding: 0em;">
          <div class="ui-inputgroup" style="margin-left: 32px;">
            <button pButton class="theme-button noHover" type="button" label="Machine"></button>
            <input style="width: 130px;" type="text" autocomplete="off" id="machinebarcode"
              formControlName="machineBarcode" placeholder="Barcode">
          </div>
        </div>

        <div class="ui-g-12 ui-md-3" style="padding: 0em;">
          <div class="ui-inputgroup">
            <button pButton class="theme-button noHover" type="button" #filePicker="ngxFilePicker"
            ngxFilePicker [readMode]="readMode"   accept="*/*" (filePick)="onFlxFilePicked($event)"
              (readEnd)="onFlxFileReadEnd($event)" label="Choose File"></button>
            <input type="text" autofocus autocomplete="off" id="pickedFlxFileName" formControlName="flxFileName"
              placeholder="Upload FLX file">
          </div>
        </div>

        <div class="ui-g-12 ui-md-3" style="padding: 0em;">
          <div class="ui-inputgroup" style="margin-left: 32px;">
            <button style="width: 217px;" pButton class="theme-button noHover" type="button"
              label="Process Samples" [disabled]="!libFLXFileUploadForm.valid" (click)="uploadFlxFile()"></button>
          </div>
        </div>

      </div>
    </form>
  </p-fieldset>

  <div *ngIf="plateViewShow" class="plateview">
    <div class="ui-g ui-fluid centered">
      <div class="ui-g-12 ui-md-3" style="height: 35px; padding: 0; padding-top: 4px;">
        <strong style="padding-top: 2px">Assay Type information: </strong>
      </div>
      <div class="ui-g-12 ui-md-3" style="height: 35px; padding: 0; padding-top: 4px;">
        <div class="legendHSNGS" style="float: left;">
        </div>
        <div class="assayTypeLabel">HS NGS Fragment Count: <p [class]="assayTypeChangeClass" style="float: right; padding-left: 2px;">{{assayTypeCounts.HSNGS}}</p></div>
      </div>
      <div class="ui-g-12 ui-md-3" style="height: 35px; padding: 0px; padding-top: 4px;">
        <div class="legendSSNGS" style="float: left;">
        </div>
        <div class="assayTypeLabel">SS NGS Fragment Count: <p [class]="assayTypeChangeClass" style="float: right; padding-left: 2px;">{{assayTypeCounts.SSNGS}}</p></div>
    </div>
    <div class="ui-g-12 ui-md-2" style="padding: 0; padding-top: 5px;">
      <button pButton class="action-button" icon="fa fa-save" type="button" label="Save AssayType Changes" (click)="saveAssayTypeChanges()" [disabled]="!activateSaveButton()"></button>
      </div>
    </div>  
    <div>
  <table data-vertable="ver5" aria-describedby="Scan Table" id="scanTable" class="table" style="width: 97vw;" [hidden]="viewTable">
    <thead>
      <tr class="row100 head">
        <th scope="col" class="column100 column1"></th>
        <th scope="col" class="column100 column2" *ngFor="let col of columnHeaders">{{col}}</th>
      </tr>
    </thead>
    <tbody>
        <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
          <td class="column100 column1" style="color: #006b96;font-weight: bold;">{{row}}</td>
          <td  class="column100 column2" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
            <button [class]="(getSampleAt(i, j)?.newlyPlaced == true ? 'cellviewsUNAvailable' : ((getSampleAt(i, j)?.assayType == 'SS_NGS_FRAGMENT') ? 'cellviewsSSNGS' : ((getSampleAt(i, j)?.assayType == 'HS_NGS_FRAGMENT') ? 'cellviewsHSNGS' : 'cellviewsNOASSAYTYPE')))" (click)="changeAssayType(i, j)">
              <div class="sampleInfo">
                {{getSampleAt(i, j)?.barcode}}
                </div>
                <div *ngIf="getSampleAt(i, j)?.name !== null || getSampleAt(i, j)?.projectName !== null" class="sampleInfo" >
                {{getSampleAt(i, j)?.name}} / {{getSampleAt(i, j)?.projectName}}
                </div>
                <div class="sampleInfo">
                {{getSampleAt(i, j)?.concentration}}
                </div>
            </button>
          </td>
        </tr>
    </tbody>
  </table>
</div>

<div class="ui-g ui-fluid centered">
  <div class="ui-g-8 ui-g-nopad">
  <p-fieldset legend="Generate workfile" >

    <form [formGroup]="generareWorkFileForm">
      <div class="ui-g ui-fluid centered">

        <div class="ui-g-12 ui-md-4" style="padding: 0em;">

          <input type="radio" formControlName="machineType" value="JEKYLL"
            (change)="onMachineTypeChange('JEKYLL')" />
          Jekyll (12-Capillary Array)
          <br/>
          <input type="radio" formControlName="machineType" value="HYDE"
            (change)="onMachineTypeChange('HYDE')" />
          Hyde (48-Capillary Array)
        </div>

        <div class="ui-g-12 ui-md-4"  style="padding: 0em;">
          <div class="ui-inputgroup">
            <button style="width: 105px;" pButton class="theme-button noHover" type="button"
              label="FA Plate"></button>
            <input type="text" autofocus autocomplete="off" id="createdby" [(ngModel)]="faPlateBarcode"
              placeholder="Plate barcode" formControlName="faPlateBarcode">
          </div>
        </div>

        <div class="ui-g-12 ui-md-4" style="padding: 0em;">
          <div class="ui-inputgroup" style="margin-left: 32px;">
            <button style="width: 217px;" pButton class="theme-button noHover" type="button"
              label="Create FA Workfiles" [disabled]="!generareWorkFileForm.valid"
              (click)="generateWorkFiles()"></button>
          </div>
        </div>
      </div>

    </form>
  </p-fieldset>
  </div>

</div>
</div>

<p-dialog (onAfterHide)="onPopUpClose()" [(visible)]="showPlateData" [modal]="true" header="Available FA Plate Status">
  <div class="col-md-12">
    <div>
      <p>Available Plates:</p>
    </div>
    <div class="available-plate-data-div tableFixHead">
      <table class="table table-hover table-bordered" aria-describedby="Barcode Table" >
        <thead class="fixed_header">
          <tr>
            <th scope="col" style="text-align: center;">Barcode</th>
            <th scope="col" style="text-align: center;">Positions</th>
          </tr>
        </thead>
        <tbody *ngIf="faPlates != null && faPlates.length != 0">
          <tr *ngFor="let item of faPlates">
            <td>{{item.barcode}}</td>
            <td>{{item.availablePositions}}</td>
          </tr>
        </tbody>
        <tbody *ngIf="faPlates == null || faPlates.length == 0">
          <tr>
            <td colspan="2">No FA Plates Available Yet</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

